<template>
	<div>
		<v-tabs
			class="round-card"
			height="34"
			background-color="background-1"
			slider-color="primary">
			<v-tab key="Campi" ripple class="secondary-tab">
				Campi
			</v-tab>
			<v-tab key="Azioni" ripple class="secondary-tab">
				Azioni
			</v-tab>
			<v-tab key="Template" ripple class="secondary-tab">
				Template
			</v-tab>
			<v-tab key="Stampa" ripple class="secondary-tab">
				Stampa
			</v-tab>
			<v-tab key="Altro" ripple class="secondary-tab">
				Altro
			</v-tab>

			<v-tab-item class="background-1 pt-3 pb-1" key="Campi">

				<v-row class="ma-0">
					<v-col class="pa-0 pt-2" cols="12">
						<fields-selector
							model-def="saleorder"
						></fields-selector>
					</v-col>
				</v-row>
				<!-- Configuratore del dialog "Genera Ticket Service Desk" (azione multipla).
				     Solo se il modulo Helpdesk e' attivo. Solo tab Form: il dialog e' un form. -->
				<v-row class="ma-0" v-if="$store.getters.checkModulePermissions('helpdesk')">
					<v-col class="pa-0 pt-2" cols="12">
						<fields-selector
							model-def="saleorder"
							template-data="template_data_servicedesk"
							:table="false"
							:show="false"
							:custom-fields="false"
						></fields-selector>
					</v-col>
				</v-row>

				<v-row class="ma-0 pb-offset">
					<v-col class="pa-0 pt-2" cols="12">
						<fields-selector model-def="productsaleorder" audit></fields-selector>
					</v-col>
				</v-row>
			</v-tab-item>

			<v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
				<v-row class="ma-0">

					<v-col class="pa-0 pt-2" cols="12">
						<actions-selector model-def="saleorder"></actions-selector>
					</v-col>

				</v-row>
			</v-tab-item>

			<v-tab-item class="background-1 pt-3 pb-1" key="Template">
				<v-row class="ma-0">
					<v-col class="pa-0" cols="12">
						<crud
							model-def="templates-saleorder"
							action-icon="dynamic_feed"
							title="Template Ordini di vendita"
							action-position='absolute'>
						</crud>
					</v-col>
				</v-row>
			</v-tab-item>

			<v-tab-item class="background-1 pt-3 pb-1" key="Stampa">
				<v-row class="ma-0">
					<v-col class="pa-0" cols="12">
						<orders-print></orders-print>
					</v-col>
				</v-row>
			</v-tab-item>

			<v-tab-item class="background-1 pt-3 pb-1" key="Altro">
				<v-row class="ma-0">
					<orders-other></orders-other>
				</v-row>
			</v-tab-item>
		</v-tabs>

	</div>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import OrdersOther from '@/components/modules/orders/settings/OrdersOther'
import OrdersPrint from '@/components/modules/orders/settings/OrdersPrint'

	export default {
		name:'orders-settings',
        components: {
            OrdersOther,
			OrdersPrint,
			FieldsSelector,
			ActionsSelector,
        },
	}
  </script>
